import { Get_Token } from 'resolvers/Get_Token';
import httpClient from './apiService';

export const createKYXEvent = async body => {
    const response = await httpClient.post('/analytics/kyx', body, {
        headers: {
            Authorization: `Bearer ${Get_Token()}`
        }
    });
    return response.data;
};
